import { TaggedError } from "../tagged-error.js";
export class AccessTokenExpiredError extends TaggedError {
    constructor() {
        super("AccessTokenExpiredError");
    }
}
export class RefreshTokenExpiredError extends TaggedError {
    constructor() {
        super("RefreshTokenExpiredError");
    }
}
export class AccessTokenInvalidError extends TaggedError {
    constructor() {
        super("AccessTokenInvalidError");
    }
}
export class RefreshTokenInvalidError extends TaggedError {
    constructor() {
        super("RefreshTokenInvalidError");
    }
}
